import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ModalDialog } from 'components/ModalDialog';
import { useRequest } from 'features/request/useRequest';
import { useAgGridDataSource } from 'hooks/useAgGridDataSource';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getAgreementRatioForIncluding } from '../AgreementsQueries';

import { useAgreementsUersForRatioColumns } from './useAgreementsRatioColumns';

import './AgreementsAddRatio.css';

export const AgreementsRatioInfoTable = ({
    ratioName,
    closeRatioInfoTable,
}: {
    ratioName: string;
    closeRatioInfoTable: () => void;
}) => {
    const { agreementId } = useParams();
    const modalTitle = useMemo(() => `Расценки к коэффициенту ${ratioName}`, [ratioName]);

    const [queryWhere, setQueryWhere] = useState({
        code: {
            eq: ratioName,
        },
    });

    const changeFilterHandler = useCallback(
        ({ checkedValues, fieldName }: { checkedValues: string[]; fieldName: string }) => {
            setQueryWhere((prev) => ({
                ...prev,
                [fieldName]: { in: checkedValues?.length ? checkedValues : undefined },
            }));
        },
        [],
    );

    const variables = useMemo(
        () => ({
            contractChangeId: Number(agreementId),
            where: { and: [queryWhere] },
        }),
        [agreementId, queryWhere],
    );

    const [infoData, , , infoDataRequest] = useRequest({
        requestId: 'ratioUersInfo',
        query: getAgreementRatioForIncluding,
        variables,
        withEffect: false,
    });

    const { dataSource, getRowParams } = useAgGridDataSource({
        requestId: 'ratioUersInfo',
        requestFn: infoDataRequest,
        requestVariables: variables,
    });

    const agreementsUerForRatioColumns = useAgreementsUersForRatioColumns({
        ratioName,
        agreementId: Number(agreementId),
        changeFilterHandler,
    });

    useEffect(() => {
        if (infoData?.uerPriceListRatioForIncludingToContractChange?.items && getRowParams?.current) {
            getRowParams?.current?.successCallback(
                infoData.uerPriceListRatioForIncludingToContractChange.items ?? [],
                infoData.uerPriceListRatioForIncludingToContractChange?.totalCount,
            );
        }
    }, [
        getRowParams,
        infoData?.uerPriceListRatioForIncludingToContractChange?.items,
        infoData?.uerPriceListRatioForIncludingToContractChange?.totalCount,
    ]);

    return (
        <ModalDialog
            isOpen={!!ratioName}
            title={modalTitle}
            onClose={closeRatioInfoTable}
            isOnClickOutsideDisable
            btnCancelLabel="Закрыть"
            withTitleCloseButton
            bodyWidth={1000}
            btnCancelView="primary"
        >
            <div id="AgreementsRatioInfo" style={{ height: '45vh', padding: '20px' }}>
                <div style={{ height: '100%' }}>
                    <AgGridTable
                        columnDefs={agreementsUerForRatioColumns}
                        datasource={dataSource}
                        maxConcurrentDatasourceRequests={1}
                        maxBlocksInCache={50}
                        cacheBlockSize={50}
                        rowModelType="infinite"
                    />
                </div>
            </div>
        </ModalDialog>
    );
};

AgreementsRatioInfoTable.displayName = 'AgreementsRatioInfoTable';
